<template>
  <!-- 通用线型数据排行榜2-显示两个数据 100/200这种方式 -->
  <div class="item-rank">
    <yq-empty description="正在加载中" v-if="itemCount.length === 0" style="padding: 0;opacity: .3"/>
    <div class="rank-item" v-else>
      <div class="rank-item-name">
        <div v-for="(item, i) in itemCount" :key="i" class="rank-data">{{item.itemName}}</div>
      </div>
      <div class="rank-item-percent" >
        <div v-for="(item, i) in itemCount" :key="i" class="rank-data">
          <div class="percent-background">
            <div class="percent" :style="{'width': item.percent + '%', backgroundColor: rankColor[item.color]}"></div>
          </div>
        </div>
      </div>
      <div class="rank-item-count">
        <div v-for="(item, i) in itemCount" :key="i" class="rank-data">
          <span :class="item.color === 'warning'? 'count-warning': ''">{{item.count}}</span>
          <span>/</span>
          <span>{{item.allCount}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import {watch} from "vue";

export default {
  props: {
    // 数据格式 [{itemName: "名称", count: 100, allCount: 200}]
    dataList: {
      default: () => [{itemName: "名称", count: 180, allCount: 200},{itemName: "名称", count: 150, allCount: 200},{itemName: "名称", count: 110, allCount: 200},{itemName: "名称", count: 20, allCount: 100}],
    },
    // 颜色，需要指定三个颜色
    rankColor: {default: () => {
      return {
        standard: "#63fbfb",
        normal: "#0087aa",
        warning: "#FF0000",
      }}},
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "SimpleRank2",
  components: {
  },
  data() {
    return {
      itemCount: [
        {count: 213, allCount: 102, itemName: "打卡设备"},
        {count: 188, allCount: 80, itemName: "视频设备"},
        {count: 200, allCount: 180, itemName: "无人机"},
      ],

    };
  },
  created() {
    this.init();
    watch(() => this.dataList, () => {this.init()})
  },
  methods: {
    init() {
      this.itemCount = this.dataList;
      // 计算比例
      this.itemCount.forEach(item => {
        if (!item.allCount || item.allCount === 0) {
          item.count = 0;
          item.color = "warning";
          return;
        }
        item.percent = item.count / item.allCount * 100;
        // 三个颜色，预警，正常，标准
        if (item.percent > 80) {
          item.color = "standard";
        } else if (item.percent > 60) {
          item.color = "normal";
        } else {
          item.color = "warning";
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.item-rank{
  .rank-count{
    margin-bottom: 20px;
  }
  .rank-item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    margin-bottom: 10px;
    .rank-data{
      height: 30px;
      line-height: 30px;
    }
    .rank-item-name{
      >div{
        white-space: nowrap;
      }
    }
    .rank-item-percent{
      width: 100px;
      flex: 1;
      box-sizing: border-box;
      padding: 0 20px;
      overflow: hidden;
      .rank-data{
        display: flex;
        align-items: center;
      }
      .percent-background{
        height: 5px;
        border-radius: 8px;
        background: #F56C6C;
        width: 100%;
        .percent{
          height: 5px;
          border-radius: 8px;
        }
      }
    }
    .rank-item-count{
      >div{
        white-space: nowrap;
      }
      .count-warning{
        color: var(--map-color-warn);
      }
    }
  }
}
</style>